import React, { useEffect, useMemo } from 'react';
import { Link, Head, useForm } from '@inertiajs/inertia-react';
import logo from '../../images/logo.png';
import OrderStatus from '@/Components/OrderStatus';
import { SuccessIcon, WarningIcon } from '@/Components/SweetAlertIcons';
import { DateTime } from 'luxon';
import ApplicationLogo from '@/Components/ApplicationLogo';
import Clients from '@/Components/Clients';
import Cookies from 'js-cookie';
import { useUsersRegistrationContext } from '@/context/UsersRegistration';
import { stringToURL } from '@/helpers/string';

const ValidationMessage = ({ name, consumed }) => {
    return (
        <div className="flex justify-between items-center shadow rounded-2xl bg-white pr-4 w-full">
            {
                consumed ? (
                    <>
                        <div>
                            <SuccessIcon />
                        </div>
                        <p className="text-green-400 w-full">Este ticket ya ha sido validado en {name}</p>
                    </>
                ) : (
                    <>
                        <div>
                            <WarningIcon />
                        </div>
                        <p className="text-red-400 w-full">Este ticket aun no ha sido validado en {name}</p>
                    </>
                )
            }
        </div>
    )
}

export default function ShowOrder({
    order,
   // reservation,
    schedules,
    isValidator,
    digestStatus,
    consentLink,
    tickets_number,
    price,
    coupon,
    products,
    store,
    scheduleType,
    order_type,
    ...props
}) {

    const { removeUsersRegistration } = useUsersRegistrationContext();

    const getMessage = (type = 'default') => {
        const messages = {
            'in_process': 'Compra no verificada. Por favor, vuelve a verificar más adelante refrescando esta página.',
            'in_mediation': 'Compra en mediación. Por favor, confirma tu compra y quedará habilitada refrescando esta página.',
            'pending': (() => {
                if (order.bulk_order?.uuid) {
                    return 'Cobro pendiente. Por favor, vuelve a verificar más adelante refrescando esta página.'
                }

                return 'Compra pendiente. Por favor, vuelve a verificar más adelante refrescando esta página.'
            })(),
            'rejected': (() => {
                if (order.bulk_order?.uuid) {
                    return 'Cobro rechazado. Por favor, vuelve a reintentar'
                }

                return 'Compra rechazada. Por favor, vuelve a reintentar'
            })(),
            'cancelled': 'Tu orden ha sido cancelada.',
            'approved': (() => {
                if (order.bulk_order?.uuid) {
                    return '¡Cobro realizado exitosamente!';
                }

                return '¡Compra realizada exitosamente!';
            })(),
            'expired': 'Lo sentimos. Tu reserva ha expirado mientras cursabas el pago. No te preocupes, reembolsaremos el importe.',
            'default': ''
        }

        return messages[type] || messages['default'];
    }


    const message = {
        'in_mediation': getMessage('in_mediation'),
        'in_process': getMessage('in_process'),
        'pending': getMessage('pending'),
        'rejected': getMessage('rejected'),
        'cancelled': getMessage('cancelled'),
        'approved': getMessage('approved'),
        'expired': getMessage('expired')
    }
    //console.log('order', order.schedule_type)
    const statusColor = digestStatus == 'approved'
        ? 'border-green-300'
        : digestStatus == 'in_process' || digestStatus == 'pending' || digestStatus == 'in_mediation'
            ? 'border-yellow-300'
            : 'border-red-600';

    const productsDetails = useMemo(() => products?.map(product => ({
        product_id: product.id,
        quantity: product.pivot.quantity,
        totalPrice: product.pivot.total_price,
        name: product.name,
        price: product.pivot.price
    })), [])

    // const downloadInvoice = () => {
    //     Inertia.post(route('download.invoice'),
    //     {
    //         trackId: order.softland_track_id,
    //         invoice: order.softland_invoice,
    //         softland_order: order.softland_order
    //     });
    // }

    //console.log({order}, {schedules})

    useEffect(() => {
        window.sessionStorage.removeItem('order_checkout_id');
        Cookies.remove('order_checkout_clients');
        removeUsersRegistration();
    }, [])


    console.log({ branch_office: order.branch_office})

    return (
        <>
            <Head title="Compra exitosa - Cerogrado" />
            <div className="relative flex items-top justify-center min-h-screen bg-gray-100 sm:items-center sm:pt-0">

                <div className="max-w-6xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-4">

                    <div className="flex justify-center pt-8 sm:pt-0">
                        <ApplicationLogo className="h-16 w-auto sm:h-20" store={store} />
                    </div>

                    <div className={`w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden rounded-lg border-2 ${statusColor}`}>
                        <h1 className='text-center text-gray-900 text-lg font-bold'>
                            {message[digestStatus]}
                        </h1>
                        {digestStatus === 'approved' && (order_type !== 'product-redelcom' && order_type !== 'product-manual') && (
                            <div>
                                <p className="text-center text-gray-900 font-bold">Hemos enviado un correo a:</p>
                                <h2 className="text-center text-gray-900 text-lg font-bold">{order.email}</h2>
                                <p className="text-center text-gray-900 font-bold">Con tu ticket digital.</p>
                            </div>
                        )}
                    </div>

                    {
                        digestStatus === 'approved' ? (
                            <div className="flex justify-center items-center w-full sm:max-w-md mt-6 overflow-hidden">
                                <a target="_blank" className="bg-primary text-white px-5 py-3 rounded-full" href={route('order.show', {uuid: order.uuid}) + '/mail'}>Ver tu ticket aquí</a>
                            </div>
                        ) : (
                            <div className="flex justify-center items-center w-full sm:max-w-md mt-6 overflow-hidden">
                                <a target="_blank" className="bg-primary text-white px-5 py-3 rounded-full" href={`mailto:cerogrado@cerogrado.cl?subject=${stringToURL(`Tengo problemas con mi compra. N° ${order.id} - ${order.uuid}`)}`}>Contáctese con soporte</a>
                            </div>
                        )
                    }


                    {(order_type !== 'product-redelcom' && order_type !== 'product-manual') && (
                        <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">

                            <h2 className='mb-3 text-gray-900 text-lg font-bold'>Datos de contacto</h2>

                            <table className='w-full'>
                                <tbody>
                                    <tr>
                                        <td>Nombres</td>
                                        <td className='text-right'>{order.first_name}</td>
                                    </tr>
                                    <tr>
                                        <td>Apellido</td>
                                        <td className='text-right'>{order.second_name}</td>
                                    </tr>
                                    <tr>
                                        <td>R.U.N</td>
                                        <td className='text-right'>{order.rut}</td>
                                    </tr>
                                    <tr>
                                        <td>Email</td>
                                        <td className='text-right'><a href={`mailto:${order.email}`}>{order.email}</a></td>
                                    </tr>
                                    <tr>
                                        <td>Teléfono</td>
                                        <td className='text-right'><a href={`tel:${order.telephone}`}>{order.telephone}</a></td>
                                    </tr>
                                </tbody>
                            </table>

                            <p className="text-sm text-gray-600 text-center mt-5">
                                <a href={order.accepted_terms} target='_blank' className='underline'>Términos y Condiciones</a>
                            </p>

                        </div>
                    )}


                    {order?.clients && order.clients.length > 0 && (order_type !== 'product-redelcom' && order_type !== 'product-manual') && (
                        <Clients clientDoesntHaveRutMessage="Asume el cliente" clients={order.clients} />
                    )}

                    <OrderStatus
                        isProductOrder={(order_type === 'product-redelcom' || order_type === 'product-manual')}
                        isBulkOrder={order.bulk_order?.uuid}
                        office={order.branch_office}
                        date={DateTime.fromSQL(order.date).toFormat('dd-MM-yyyy')}
                        discountPercent={coupon?.percent}
                        time={schedules[0]?.time}
                        scheduleType={scheduleType}
                        // adults={adults}
                        // adultsPrice={adultsPrice}
                        // children={children}
                        // childrenPrice={childrenPrice}
                        quantity={tickets_number}
                        price={price}
                        productsDetails={productsDetails}
                        couponDiscountTotalWithProducts={props.COUPON_DISCOUNT_TOTAL_WITH_PRODUCTS}
                    />
                    <div>
                        {!order.bulk_order?.uuid && order.softland_order && (
                            <div className="text-center mt-8">
                                <a href={`/download-invoice?id=${order.id}&softland_order=${order.softland_order}`} className="bg-primary text-white px-5 py-3 rounded-full" target="_blank">Descargar Boleta</a>
                            </div>
                        )}

                        <div className="text-center mt-8 mb-8">
                            <Link href={`/`} className="text-primary" target="_blank">Volver al inicio</Link>
                        </div>
                    </div>
                    {/* {
                        digestStatus == 'rejected' &&
                        <div className="flex items-center justify-center mt-8 space-x-3">
                            <Link
                                href='/orders'
                                className='inline-flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150'
                                data={{schedule: schedule.id, adults: reservation.adults_tickets, children: reservation.children_tickets}}>
                                Reintentar
                            </Link>
                        </div>
                    } */}

                    {
                        (digestStatus == 'approved' && !isValidator) &&
                        <>
                            {
                                consentLink &&
                                <p className="w-full sm:max-w-md mt-6 text-center text-sm px-3 sm:px-0 font-bold">
                                    No olvides imprimir y completar el <a className="underline" href={consentLink} target='_blank'>Consentimiento informado</a>.
                                </p>
                            }
                            <p className='w-full sm:max-w-md mt-6 text-center text-sm px-3 sm:px-0'>
                                La reserva inicia a la hora indicada, por tanto, se recomienda llegar al lugar con veinte minutos de anticipación.
                                No se aceptan cambios ni devoluciones.
                            </p>
                        </>
                    }

                    <div className="flex flex-col items-center gap-4 justify-center mt-4">
                        {order.validations.map((validation) => (
                            <>
                                {validation.name === 'caja' && isValidator && (
                                    <ValidationMessage {...validation} />
                                )}

                                {validation.name === 'pista' && isValidator && (props.auth.user?.roles ? props.auth.user.roles.some(role => role.id === validation.role_id) : false) && (
                                    <ValidationMessage {...validation} />
                                )}
                            </>
                        ))}
                    </div>

                    {
                        (digestStatus == 'approved' && isValidator) &&
                        <div className='flex items-center justify-center mt-8 space-x-3'>
                            {order.validations
                                .filter(({ role_id }) => props.auth.user.roles.some(role => role.id === role_id))
                                .map(({ id, name, consumed }) => (
                                    <>
                                        {consumed ? (
                                            <div className='flex items-center px-4 py-2 border border-gray-900 rounded-md font-semibold text-xs text-gray-900'>
                                                👍 Ticket Validado en {_.lowerCase(name)}
                                            </div>
                                        ) : (
                                            <Link
                                                href={`/orders/${order.uuid}/validate/${id}`}
                                                as="button"
                                                type="button"
                                                method='put'
                                                className='flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150'
                                            >
                                                Validar ticket en {name}
                                            </Link>
                                        )}
                                    </>
                                ))}
                        </div>
                    }
                </div>

            </div>
        </>
    );
}
